import { createStore, combineReducers } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { app, user, menu, logging, period, projects } from './reducers.jsx'

const rootReducer = combineReducers({ app, user, menu, logging, period, projects })

const persistConfig = {
    key: 'weblogger',
    storage: storage,
    whitelist: ['user','menu'] // which reducer want to store
};

const pReducer = persistReducer(persistConfig, rootReducer);

const store = createStore(pReducer);

const persistor = persistStore(store);

export { persistor, store };